module.exports = __webpack_public_path__ + "static/img/icon-up.903d288.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/myBrand/component/img/icon-up.svg
// module id = nLhj
// module chunks = 55